import React, {useState} from 'react';
import SidebarFlatList from "./SidebarFlatList";
import AssetGroupSidebarTree from "./AssetGroupSidebarTree";

const CREATE_TYPE_OPTIONS = [
    {id: "code", label: "코드"},
    {id: "text", label: "텍스트"},
];

function CodeManageItemList({
    addLabel = "항목",
    addPlaceholder,
    createSectionLabel = "항목 추가",
    items = [],
    selectedItemId,
    selectedItemKey,
    onSelect,
    onCreateRoot,
    createTypeOptions,
    useAssetGroupTree = false,
    showItemKind = false,
    emptyMessage,
    showCreateSection = true,
}) {
    const [draft, setDraft] = useState("");
    const [createType, setCreateType] = useState(createTypeOptions?.[0]?.id ?? "code");
    const placeholder = addPlaceholder ?? `새 ${addLabel}명을 입력하세요`;

    const submitCreate = () => {
        const trimmed = draft.trim();
        if (!trimmed) {
            return;
        }
        if (createTypeOptions) {
            onCreateRoot?.(trimmed, createType);
        } else {
            onCreateRoot?.(trimmed);
        }
        setDraft("");
    };

    return (
        <div className="code-manage-item-list">
            <div className="code-manage-item-list__heading">{addLabel} 목록</div>
            <div className="code-manage-item-list__scroll code-manage-scroll-area">
                {!useAssetGroupTree && !items?.length && (
                    <p className="code-manage-item-list__empty">
                        {emptyMessage ?? "등록된 항목이 없습니다. 아래에서 추가하세요."}
                    </p>
                )}

                {useAssetGroupTree ? (
                    items?.length > 0 ? (
                        <AssetGroupSidebarTree
                            items={items}
                            selectedItemId={selectedItemId}
                            onSelect={onSelect}
                        />
                    ) : (
                        <p className="code-manage-item-list__empty">선택 가능한 자산그룹이 없습니다.</p>
                    )
                ) : (
                    <SidebarFlatList
                        items={items}
                        selectedItemId={selectedItemId}
                        selectedItemKey={selectedItemKey}
                        onSelect={onSelect}
                        showItemKind={showItemKind}
                    />
                )}
            </div>

            {onCreateRoot && showCreateSection && (
                <div className="code-manage-item-list__create">
                    <p className="code-manage-item-list__create-label">{createSectionLabel}</p>
                    {createTypeOptions && (
                        <div className="code-manage-item-list__create-type" role="radiogroup" aria-label="항목 유형">
                            {(createTypeOptions ?? CREATE_TYPE_OPTIONS).map((option) => (
                                <label key={option.id} className="code-manage-item-list__create-type-option">
                                    <input
                                        type="radio"
                                        name="code-manage-create-type"
                                        value={option.id}
                                        checked={createType === option.id}
                                        onChange={() => setCreateType(option.id)}
                                    />
                                    <span>{option.label}</span>
                                </label>
                            ))}
                        </div>
                    )}
                    <div className="code-manage-item-list__create-row">
                        <input
                            type="text"
                            className="code-manage-item-list__create-input basic-input input-style"
                            placeholder={placeholder}
                            value={draft}
                            onChange={(e) => setDraft(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    submitCreate();
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="save-btn"
                            onClick={submitCreate}
                        >
                            등록
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CodeManageItemList;
